export default __webpack_public_path__ + "static/media/fi-rr-angle-small-right-red.855ce433.svg";